export default "__VITE_ASSET__87ce0ac1__"